export default __webpack_public_path__ + "static/media/loader-roi.b7282b97.gif";